import { render, staticRenderFns } from "./FranchiseReport.vue?vue&type=template&id=065625a0"
import script from "./FranchiseReport.vue?vue&type=script&lang=js"
export * from "./FranchiseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports